import {CreateInstance} from './config'
const AuthenticateDeviceAPI = CreateInstance('devices/authenticate-device')
export default AuthenticateDeviceAPI
